import React from 'react';

const LABELS = {
  connecting: 'Connecting…',
  connected: 'Connected',
  reconnecting: 'Reconnecting…',
  offline: 'Offline',
};

export const ConnectionBadge = ({ status }) => (
  <span className={`conn-badge ${status}`} data-testid="connection-status" data-status={status}>
    <span className="dot" />
    {LABELS[status] || status}
  </span>
);
